module.exports = __webpack_public_path__ + "static/media/Fun88-Affiliate_CN_Mobile.6ad6dba5.png";